import React, { Component } from 'react';
import close from "../images/icons/close.png"
import $ from "jquery";
import { getData } from '../services';
import LazyLoad from 'react-lazyload';
import { printParams } from "../config";
import LocationIco from "../images/lokal/location-ico.png"
import Close from "../images/lokal/close.png"
import Search from "../images/lokal/search-icon.png"
export default class lokalLocation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      locationDetails: [],
      locationDetailsCopy: [],
      textLocation: '',
      locationId: '',
      cityDetails: []
    }
    this.goClick = this.goClick.bind(this)
    this.checkStoreInLocation = this.checkStoreInLocation.bind(this)
    this.onLocationTextChanged = this.onLocationTextChanged.bind(this)
    this.onCityTextChanged = this.onCityTextChanged.bind(this)
    this.locationCloseClick = this.locationCloseClick.bind(this)
    this.locationClick = this.locationClick.bind(this)
  }
  componentDidMount() {

    this.fetchLocationDetails()
    $(".newLocationPopup").hide();
    if(localStorage.getItem('locationId') == null){
      $(".loginHead").show();
      $(".popOverlay").show();
    }else{
      $(".newLocationPopup").show();
    }
  }
  fetchCityDetails() {
    let myCategoryId = window.sessionStorage.getItem('siteCategoryId');
    var key = $("#txtCityLokal").val();
    let storeId = ''
    var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
    if (subDomainFlag === '1') {
      storeId = window.sessionStorage.getItem('storeId');
    }
    const postData = {
      functionName: "lokal/cityList",
      myCategoryId: myCategoryId,
      cityKeyWord: key,
      storeId: storeId
    }
    getData(postData).then((data) => {
      if (data.data.success === "1") {
        $("#citySearch").show();
        if (data.data.result.cityDetails.length === 1 && subDomainFlag === '1') {
          this.suggestionCitySelected(data.data.result.cityDetails[0].cityId, data.data.result.cityDetails[0].cityName)
        }
        else {
          $("#locationSearch").hide();
          this.setState({
            cityDetails: data.data.result.cityDetails,
            locationDetails: []
            
          });
        }
      }
      else {
        $("#citySearch").hide();
        $("#locationSearch").hide();
        this.setState({
          cityDetails: [],
          locationDetails: []
        });
      }
    });
  }
  fetchLocationDetails() {
    {console.log("pppppppppppppppppppppppp")}
    let myCategoryId = window.sessionStorage.getItem('siteCategoryId');
    let storeId = ''
    let sellerId = window.sessionStorage.getItem('sellerId');
    var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
    if (subDomainFlag === '1') {
      if(sellerId === "0" || sellerId === "" || sellerId === "null")
      {
        storeId = window.sessionStorage.getItem('storeId');
        sellerId = ''
      }
    }
    var key = $("#txtLocationLokal").val();
    let cityId = '';
    let displayCity = window.sessionStorage.getItem('displayCity')
    if (displayCity === "1") {
      cityId = $("#hidCityId").val()
    }
  
    const postData = {
      functionName: "lokal/locationList",
      myCategoryId: myCategoryId,
      cityId: cityId,
      locationKeyword: key,
      storeId: storeId,
      sellerId:  sellerId === 'null' ? "" : sellerId,
    }
    getData(postData).then((data) => {
      if (data.data.success === "1") {
        $("#locationSearch").show();
        {console.log("pppppppppppppppppppppppp,",data.data.result.locationDetails)}
        this.setState({
          locationDetails: data.data.result.locationDetails,
          locationDetailsCopy : data.data.result.locationDetails
        });
      }
      else {
        $("#locationSearch").hide();
        this.setState({
          locationDetails: [],
          locationDetailsCopy:[]
        });
      }
      $(".locationClear").show();
    });
  }
  startWithIgnoringCase(text,other){
    return (text.toLowerCase().includes(other.toLowerCase()))
  }
  onLocationTextChanged = (e) => {
    let filterbusiness;
    if(e.target.value === ""){
      filterbusiness = this.state.locationDetailsCopy
    }
    else{
  filterbusiness =  this.state.locationDetailsCopy.filter((x) => {
      return this.startWithIgnoringCase(x.locationName, e.target.value);
    });    
  }
    this.setState({
      locationDetails: filterbusiness
    });
  }
  onCityTextChanged = (e) => {
    $("#citySearch").show();
    this.fetchCityDetails()
  }
  suggestionCitySelected(cityId, cityName) {
    $("#citySearch").hide();
    $("#txtCityLokal").val(cityName)
    $("#hidCityId").val(cityId)
    localStorage.setItem('locationId', "");
    localStorage.setItem('locationText', "");
    this.fetchLocationDetails()
  }
  suggestionLocationSelected(value, locationId, cityId, cityName, city, locationNameOnly) {
    $("#txtLocationLokal").val(value)
    localStorage.setItem('cityId', cityId);
    localStorage.setItem('cityText', cityName);
    localStorage.setItem('cityNameOnly', city);
    localStorage.setItem('locationNameOnly', locationNameOnly);
    this.setState({
      textLocation: value,
      locationId: locationId
    }, () => {
      this.checkStoreInLocation()
    });
  }
  checkStoreInLocation() {
    var storeId = []
    var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
    for (var i = 0; i < selectGroceryItemCart.length; i++) {
      storeId.push(selectGroceryItemCart[i].storeId)
    }
    var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
    for (var j = 0; j < selectCommonItemCart.length; j++) {
      storeId.push(selectCommonItemCart[j].storeId)
    }
    var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
    for (var k = 0; k < selectRestaurantCart.length; k++) {
      storeId.push(selectRestaurantCart[k].storeId)
    }
    if (storeId.length > 0) {
      var storeIdSplit = storeId.toString().replace(/[\[\]']+/g, '')
      const postData = {
        "functionName": "lokal/storeLocation",
        "storeId": storeIdSplit,
        "locationId": $("#hidLocationId").val()
      }
      getData(postData).then((data) => {
        if (data.data.success === "1") {
          if (data.data.result.cartClearFlag == "1") {
            var a = window.confirm(data.data.result.message)
            if (a) {
              this.removeCartItems(data.data.result.storeIds);
              this.goClick();
            }
            else {
              $("#txtLocationLokal").val('');
              $(".locationClear").hide();
            }
          }
          else {
            this.goClick();
          }
        }
      })
    }
    else {
      this.goClick();
    }
  }
  removeCartItems(storeIds) {
    var storeIdSpit = storeIds.split(',')
    for (var s = 0; s < storeIdSpit.length; s++) {
      var storeId = storeIdSpit[s]
      var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
      var cookieNewGroceryItemValue = []
      var j = 0
      for (var i = 0; i < selectGroceryItemCart.length; i++) {
        if (storeId != selectGroceryItemCart[i].storeId) {
          cookieNewGroceryItemValue[j] =
          {
            storeId: selectGroceryItemCart[i].storeId.toString().trim(),
            item_names: selectGroceryItemCart[i].item_names.toString().trim(),
            item_ids: selectGroceryItemCart[i].item_ids.toString().trim(),
            quantity: selectGroceryItemCart[i].quantity.toString().trim(),
            item_prices: selectGroceryItemCart[i].item_prices.toString().trim(),
            store_item_stock_ids: selectGroceryItemCart[i].store_item_stock_ids.toString().trim(),
            pack_ids: selectGroceryItemCart[i].pack_ids.toString().trim(),
            stock_quantity: selectGroceryItemCart[i].stock_quantity.toString().trim(),
            item_image: selectGroceryItemCart[i].item_image.toString().trim(),
            itemNo: selectGroceryItemCart[i].itemNo.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectedCartProduct', JSON.stringify(cookieNewGroceryItemValue))
      var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
      var cookieNewCommonItemValue = []
      j = 0
      for (var i = 0; i < selectCommonItemCart.length; i++) {
        if (storeId != selectCommonItemCart[i].storeId) {
          cookieNewCommonItemValue[j] =
          {
            storeId: selectCommonItemCart[i].storeId.toString().trim(),
            itemId: selectCommonItemCart[i].itemId.toString().trim(),
            itemName: selectCommonItemCart[i].itemName.toString().trim(),
            quantity: selectCommonItemCart[i].quantity.toString().trim(),
            itemTitle: selectCommonItemCart[i].itemTitle.toString().trim(),
            brand: selectCommonItemCart[i].brand.toString().trim(),
            sizeName: selectCommonItemCart[i].sizeName.toString().trim(),
            sizeId: selectCommonItemCart[i].sizeId.toString().trim(),
            cmItemSizeId: selectCommonItemCart[i].cmItemSizeId.toString().trim(),
            itemMasterId: selectCommonItemCart[i].itemMasterId.toString().trim(),
            netAmount: selectCommonItemCart[i].netAmount.toString().trim(),
            mrp: selectCommonItemCart[i].mrp.toString().trim(),
            itemImage: selectCommonItemCart[i].itemImage.toString().trim(),
            itemNo: selectCommonItemCart[i].itemNo.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectCommonItemCart', JSON.stringify(cookieNewCommonItemValue))
      var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
      var cookieNewRestaurantValue = []
      j = 0
      for (var i = 0; i < selectRestaurantCart.length; i++) {
        if (storeId != selectRestaurantCart[i].storeId) {
          cookieNewRestaurantValue[j] =
          {
            storeId: selectRestaurantCart[i].storeId.toString().trim(),
            itemId: selectRestaurantCart[i].itemId.toString().trim(),
            itemName: selectRestaurantCart[i].itemName.toString().trim(),
            quantity: selectRestaurantCart[i].quantity.toString().trim(),
            itemSize: selectRestaurantCart[i].itemSize.toString().trim(),
            itemMrp: selectRestaurantCart[i].itemMrp.toString().trim(),
            itemImage: selectRestaurantCart[i].itemImage.toString().trim(),
            storeItemSizeId: selectRestaurantCart[i].storeItemSizeId.toString().trim(),
            itemNo: selectRestaurantCart[i].itemNo.toString().trim(),
            toppingsData: selectRestaurantCart[i].toppingsData.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectRestaurantCart', JSON.stringify(cookieNewRestaurantValue))
    }
  }
  categorySelection(){
    let locationId = '';
    if (this.props.fromPage !== 'lokalHome') {
        locationId = localStorage.getItem('locationId');
    }
    const postData = {
      "functionName": "lokal/category",
      "myCategoryId": window.sessionStorage.getItem('siteCategoryId'),
      "locationId": locationId
  }

  getData(postData).then((data) => {
      console.log("categorydata ", data)
      if (data.data.success === "1") {
          if (data.data.result.category.length === 1) {
            const obj = data.data.result.category[0];
            this.setCategorySessions1(obj, 'hasLocation')
              window.sessionStorage.setItem('mainCategoryIdLokal', obj.id)
              window.sessionStorage.setItem('mainCategoryId', obj.id)
              window.sessionStorage.setItem('storeName', '')
              window.sessionStorage.setItem('storeId', '')
              window.sessionStorage.setItem('mainCategoryAlternativeName', obj.alternativeName)
              
          }
          else {
            window.location.href = "/category";
          }
      }
      else {
          this.setState({
              isData: '0'
          });
      }
  });
  }
  setCategorySessions1(obj, flag) {
    let title = obj.seoTitle.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    let description = obj.seoDescription.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    let slug = obj.seoSlug.replace('{{City}}', localStorage.getItem('cityNameOnly').toLowerCase()).replace('{{Location}}', localStorage.getItem('locationNameOnly').toLowerCase().trim().replace(/ /g, '-'))
    let h1 = obj.seoH1.replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    window.sessionStorage.setItem('mainCategorySeoTitle', title)
    window.sessionStorage.setItem('mainCategorySeoDescription', description)
    window.sessionStorage.setItem('mainCategorySeoSlug', slug)
    window.sessionStorage.setItem('mainCategorySeoH1', h1)
    if (flag === "hasLocation") {
        window.location.href = slug
    }
}
  goClick() {
    let themeId = localStorage.getItem('themeId')
    let sellerId = '';
    let sellerIdSessiom = window.sessionStorage.getItem('sellerId')
    var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
    if (subDomainFlag === '1') {
      if(sellerIdSessiom !== "0" && sellerIdSessiom !== "" && sellerIdSessiom !== "null"  && sellerIdSessiom !== null)
      {
        sellerId = sellerIdSessiom
      }
      else{
        sellerId =""
      }
    }
    if ($("#txtLocationLokal").val() === "") {
      alert("location required")
      $("#txtLocationLokal").focus()
      return false;
    }
    else if ($("#txtLocationLokal").val() !== "") {
      var locationData = this.state.locationDetails.map((loc) => loc.locationName)
      if (locationData !== "") {
        var location = $("#txtLocationLokal").val();
        if (!locationData.includes(location)) {
          alert("invalid location")
          $("#txtLocationLokal").focus()
          return false;
        }
        else {
          const postData = {
            functionName: "lokal/storeByLocationId",
            siteCategoryGroupId: window.sessionStorage.getItem('siteCategoryId'),
            locationId: $("#hidLocationId").val(),
            cityId: "",
            "sellerId":sellerId
          }
          getData(postData).then((data) => {
            printParams("lokal/storeByLocationId", data)
            if (data.data.success === "1") {
             // window.sessionStorage.setItem('storeMobile', 'aaaa');
              window.sessionStorage.removeItem('storeName');
              window.sessionStorage.removeItem('storeId');
              if (subDomainFlag === '1') {
                if(sellerId !== "0" && sellerId !== ""  && sellerId !== "null" && sellerId !== null)
                {
                  window.sessionStorage.setItem('storeId',data.data.result[0])
                  window.sessionStorage.setItem('storeIdfromSubdomainSeller',data.data.result[0])
                  
                }
              }
              window.sessionStorage.setItem('storeIdsBasedOnLocation', data.data.result)
              localStorage.setItem('locationId', $("#hidLocationId").val());
              localStorage.setItem('locationText', $("#txtLocationLokal").val());
              if (themeId === '36' && subDomainFlag !== '1') {
                window.location.href = "/themeLocationhome";
              }
              else if ((themeId === '34'|| themeId === '29'|| themeId === '4') && subDomainFlag !== '1') {


                var mainCategoryIdBeforLocation = window.sessionStorage.getItem('mainCategoryIdBeforLocation')
                if (mainCategoryIdBeforLocation != null && mainCategoryIdBeforLocation != '') {
                  let slug = this.setCategorySessions()
                  window.location.href = slug;
                }
                else if ( themeId === '29'){
                  window.location.href = "/";
                }
                else {
                  this.categorySelection()
                  // window.location.href = "/category";
                }
              }
              else {
                window.location.href = "/";
              }
            }
            else {
              alert(data.data.errorMessage)
            }
          })
        }
      }
      else {
        alert("invalid location")
        $("#txtLocationLokal").focus()
        return false;
      }
    }
    else {
      localStorage.setItem('cityId', $("#hidCityId").val());
      localStorage.setItem('locationId', $("#hidLocationId").val());
      localStorage.setItem('cityText', $("#txtCityLokal").val());
      localStorage.setItem('locationText', $("#txtLocationLokal").val());
      if (themeId === '36') {
        window.location.href = "/themeLocationhome";
      }
      else {
        window.location.href = "/";
      }
    }
  }

  setCategorySessions() {
    let obj = JSON.parse(window.sessionStorage.getItem('mainCategoryDetails'))
    let title = obj.seoTitle.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    let description = obj.seoDescription.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    let slug = obj.seoSlug.replace('{{City}}', localStorage.getItem('cityNameOnly').toLowerCase()).replace('{{Location}}', localStorage.getItem('locationNameOnly').toLowerCase().trim().replace(/ /g, '-'))
    let h1 = obj.seoH1.replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    window.sessionStorage.setItem('mainCategorySeoTitle', title)
    window.sessionStorage.setItem('mainCategorySeoDescription', description)
    window.sessionStorage.setItem('mainCategorySeoSlug', slug)
    window.sessionStorage.setItem('mainCategorySeoH1', h1)
    return slug;
  }
  locationClose() {
    $("#txtLocationLokal").val('');
    $(".locationClear").hide();
  }
  locationCloseClick() {
    // $("#txtLocationLokal").val('');
    // $(".locationClear").hide();
    // $(".newLocationPopup").hide();
    // $(".loginHead").hide();
    // $(".popOverlay").hide();
    // $(".locationPopUp").hide();
    // $(".popupWrap").hide();
    var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
    let locationId = localStorage.getItem('locationId');
      if (subDomainFlag === '1') {
        if (locationId !== 'null' && locationId !== null && locationId !== '') {
          $(".popupWrap").hide();
        }
        else {
          $(".popupWrap").show();
        }
      }
      else {
        $(".popupWrap").hide();
      }
    
  }
  locationClick() {
    $(".newLocationPopup").show();
    $(".loginHead").hide();
    
  }
  render() {
    const themeId = localStorage.getItem('themeId')
    const { textLocation } = this.state;
    const { locationId } = this.state;
    if (textLocation == "") {
      this.state.locationId = "";
    }
    return (
      
      <div>
        {themeId !== '4' ? 
        <>
        <div className="popOverlay"></div>
        <div className="loginPop">
          <div className="loginHead">
          <LazyLoad once>
            <span className="loginClose"><img src={close} alt=""/></span>
            </LazyLoad>
            <div className="loginText">Choose Delivery Location</div>
          </div>
          <div className="loginForm">
            <div className="loginFormList">
              <input type="hidden" value={locationId} id="hidLocationId" />
              <input type="hidden" id="hidCityId" />
              <input autoComplete="off" onChange={this.onLocationTextChanged} onKeyUp={this.onLocationTextChanged} type="text" id="txtLocationLokal" className="inputField" placeholder="Your Delivery Location ( area, landmark... )" />
              <ul className="autoSearch" id="locationSearch" style={{ display: 'none' }}>
                {this.state.locationDetails.map((location, index1) => (
                  <li key={index1} onClick={() => this.suggestionLocationSelected(location.locationName, location.locationId, location.cityId, location.cityName, location.city, location.locationNameOnly)}>
                    <span>{location.locationName}</span>
                    <br />
                    <small>{location.city} ({location.stateName})</small>
                  </li>
                ))}
              </ul>
              <span className="locationClear" onClick={this.locationClose}>x</span>
              <span onClick={this.checkStoreInLocation} className="goButton">Go</span>
            </div>
          </div>
        </div>
        </>
        :
        <>
      <div className="popOverlay"></div>
      <div className="loginPop">
        {localStorage.getItem('locationId') == null && 
        <div className="loginHead">

          <div className='close-icon'>
            <img src={Close} alt="Close" width="14" height="14" onClick={() => this.locationCloseClick()} />
          </div>

          <div className='d-flex mt-2'>
            <div className='search-location'>
              <img src={LocationIco} alt="LocationIco" width="40" height="50" />
            </div>
            <div className='search-paragraph'>
              Could you please share your location with us?
              It'll help us serve you better!
            </div>
          </div>
          <div className='text-center' onClick={() => this.locationClick()}>
            <div className='search-delivery-btn mb-4'>
              Search delivery location
            </div>
          </div>
        </div>
  }
        <div className='newLocationPopup'>
        <div className='location-search-popup'>
          <div className='location-name'>
            Enter your location
          </div>
          <div className='close-icon-search'>
            <img src={Close} alt="Close" width="14" height="14" onClick={this.locationCloseClick}/>
          </div>
        </div>
        <div className="loginForm">
          <div className="loginFormList">
            <input type="hidden" value={locationId} id="hidLocationId" />
            <input type="hidden" id="hidCityId" />
            <input autoComplete="off" onChange={this.onLocationTextChanged} onKeyUp={this.onLocationTextChanged} type="text" id="txtLocationLokal" className="inputField" placeholder="Your Delivery Location ( area, landmark... )" />
            <ul className="autoSearch" id="locationSearch" style={{ display: 'none' }}>
              {this.state.locationDetails.map((location, index1) => (
                <li key={index1} onClick={() => this.suggestionLocationSelected(location.locationName, location.locationId, location.cityId, location.cityName, location.city, location.locationNameOnly)}>
                  <span>{location.locationName}</span>
                  <br />
                  <small>{location.city} ({location.stateName})</small>
                </li>
              ))}
            </ul>
            <span className="locationClear" onClick={this.locationClose}>
              <img src={Search} alt="Search" className='img-fluid' width="20" height="20" />
            </span>

          </div>
        </div>
        </div>
      </div>
      </>
}
      </div>


      // *******************************************************************************************************
   

    )
  }
}